import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,  // Automatically refresh tokens before expiry
    persistSession: true,     // Persist session across page reloads
    detectSessionInUrl: true, // Detect OAuth sessions in URL (for email confirmations)
    storage: window.localStorage, // Use localStorage for session persistence
    storageKey: 'supabase_session', // Match the key used in Login.tsx
    flowType: 'pkce' // Use PKCE flow for enhanced security
  }
});
